import { render, staticRenderFns } from "./FulfilmentOptions.vue?vue&type=template&id=229f1f9d&scoped=true"
import script from "./FulfilmentOptions.vue?vue&type=script&lang=js"
export * from "./FulfilmentOptions.vue?vue&type=script&lang=js"
import style0 from "./FulfilmentOptions.vue?vue&type=style&index=0&id=229f1f9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229f1f9d",
  null
  
)

export default component.exports